import styled from 'styled-components';

import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  box-shadow: 5px 5px 50px -5px rgba(128,128,128,0.75);
  background: white;
  height: 300px;
  position: absolute;
  width: 500px;
`;

const ContextComponent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  height: 100%;
  width: 100%;
  word-wrap: break-word;
`;

const Header = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #EBEBEB;
  -webkit-app-region: drag;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: hidden;
  padding: 20px;
`;

const Context = styled.div`
  align-self: flex-start;
  overflow-y: auto;
  margin-bottom: 20px;
  display: flex;
  white-space: pre-wrap;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    background: #477AE9;
    border-radius: 3px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    color: #FFFFFF;
    font-weight: 500;
    margin: 0px;
    min-width: 100px;
    padding-left: 15px;
    padding-right: 15px;

    :hover {
      background: #1954D3;
    }

    :active {
      background: #123C96;
    }
  }
`;

export {
  Button,
  ButtonContainer,
  Container,
  Content,
  Context,
  ContextComponent,
  Header,
};
